module.exports = __webpack_public_path__ + "static/media/Asset freeze and prohibition to make funds available.bac4f629.png";